export default ({ store }) => {
  store.dispatch('client/fetchClients')
}
